import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';
import Select from 'react-select';

const MonthSelect = ({ isOpen, setIsOpen, setFinalMonth }) => {
    const handleClose = () => setIsOpen(false);

    const months = [
        { label: 'January', value: 0 },
        { label: 'February', value: 1 },
        { label: 'March', value: 2 },
        { label: 'April', value: 3 },
        { label: 'May', value: 4 },
        { label: 'June', value: 5 },
        { label: 'July', value: 6 },
        { label: 'August', value: 7 },
        { label: 'September', value: 8 },
        { label: 'October', value: 9 },
        { label: 'November', value: 10 },
        { label: 'December', value: 11 }
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i).map((year) => ({ label: year, value: year }));

    const today = new Date();
    const [month, setMonth] = useState(months.find((month) => month.value === today.getMonth()));
    const [year, setYear] = useState(years.find((year) => year.value === today.getFullYear()));
    const [isLoading, setIsLoading] = useState(false);

    const handleModifyDashboard = () => {
        setIsLoading(true);
        const finalMonth = `${year.value}-${month.value+1}-01`;
        setFinalMonth(finalMonth);

        setTimeout(() => {
            setIsLoading(false);
            handleClose();
        }, 500);
    };

    const resetForm = () => {
        setMonth(months.find((month) => month.value === today.getMonth()));
        setYear(years.find((year) => year.value === today.getFullYear()));
    };

    useEffect(() => {
        if (isOpen) {
            resetForm();
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader borderRadius="md" backgroundColor="#edf2f7">Modify Dashboard Month</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl mb={4}>
                        <FormLabel>Month</FormLabel>
                        <Select
                            placeholder="Select month"
                            value={month}
                            onChange={(selectedOption) => setMonth(selectedOption)}
                            options={months}
                        />
                    </FormControl>

                    <FormControl mb={4}>
                        <FormLabel>Year</FormLabel>
                        <Select
                            value={year}
                            onChange={(selectedOption) => setYear(selectedOption)}
                            options={years}
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button
                        colorScheme="blue"
                        mr={3}
                        isLoading={isLoading}
                        onClick={handleModifyDashboard}
                    >
                        Modify Dashboard
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => {
                            handleClose();
                            resetForm();
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default MonthSelect;